import { Injectable } from '@angular/core';
import {
  MobileConsultationSections,
  UpdateMobileConsultationSections,
} from '../../domain/models/mobile-consultation-sections.model';
import {
  MobileConsultationSectionsDto,
  UpdateMobileConsultationSectionsRequestDto,
} from '../dtos/mobile-consultation-sections.dto';

@Injectable()
export class MobileConsultationSectionsMapper {
  public toMobileConsultationSections(dto: MobileConsultationSectionsDto): MobileConsultationSections {
    return {
      vitalsEnabled: dto.VitalsEnabled,
      diagnosesEnabled: dto.DiagnosesEnabled,
      signsEnabled: dto.SignsEnabled,
      medicinesEnabled: dto.MedicinesEnabled,
      proceduresEnabled: dto.ProceduresEnabled,
      analysisEnabled: dto.AnalysisEnabled,
      plansEnabled: dto.PlansEnabled,
      prescriptionsEnabled: dto.PrescriptionsEnabled,
      notesEnabled: dto.NotesEnabled,
      attachmentsEnabled: dto.AttachmentsEnabled,
      invoiceEnabled: dto.InvoiceEnabled,
      overviewEnabled: dto.OverviewEnabled,
      dischargeEnabled: dto.DischargeEnabled,
    };
  }

  public toUpdateRequest(model: UpdateMobileConsultationSections): UpdateMobileConsultationSectionsRequestDto {
    return {
      VitalsEnabled: model.vitalsEnabled,
      DiagnosesEnabled: model.diagnosesEnabled,
      SignsEnabled: model.signsEnabled,
      MedicinesEnabled: model.medicinesEnabled,
      ProceduresEnabled: model.proceduresEnabled,
      AnalysisEnabled: model.analysisEnabled,
      PlansEnabled: model.plansEnabled,
      PrescriptionsEnabled: model.prescriptionsEnabled,
      NotesEnabled: model.notesEnabled,
      AttachmentsEnabled: model.attachmentsEnabled,
      InvoiceEnabled: model.invoiceEnabled,
    };
  }
}
